import type { SVGProps } from "react";

export function PercentIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      {...props}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M5 15L15 5M13.3333 14.1667C13.3333 14.3877 13.4211 14.5996 13.5774 14.7559C13.7337 14.9122 13.9457 15 14.1667 15C14.3877 15 14.5996 14.9122 14.7559 14.7559C14.9122 14.5996 15 14.3877 15 14.1667C15 13.9457 14.9122 13.7337 14.7559 13.5774C14.5996 13.4211 14.3877 13.3333 14.1667 13.3333C13.9457 13.3333 13.7337 13.4211 13.5774 13.5774C13.4211 13.7337 13.3333 13.9457 13.3333 14.1667ZM5 5.83333C5 6.05435 5.0878 6.26631 5.24408 6.42259C5.40036 6.57887 5.61232 6.66667 5.83333 6.66667C6.05435 6.66667 6.26631 6.57887 6.42259 6.42259C6.57887 6.26631 6.66667 6.05435 6.66667 5.83333C6.66667 5.61232 6.57887 5.40036 6.42259 5.24408C6.26631 5.0878 6.05435 5 5.83333 5C5.61232 5 5.40036 5.0878 5.24408 5.24408C5.0878 5.40036 5 5.61232 5 5.83333Z"
        stroke="#85837D"
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
